export enum ArticleActionTypes {
  GET_ARTICLE_REQUEST = '[Article] GET_ARTICLE_REQUEST',
  GET_ARTICLE_SUCCESS = '[Article] GET_ARTICLE_SUCCESS',
  GET_ARTICLE_ERROR = '[Article] GET_ARTICLE_ERROR',

  DELETE_ARTICLE_REQUEST = '[Article] DELETE_ARTICLE_REQUEST',
  DELETE_ARTICLE_SUCCESS = '[Article] DELETE_ARTICLE_SUCCESS',
  DELETE_ARTICLE_ERROR = '[Article] DELETE_ARTICLE_ERROR',
}
